<template>
  <p-property-tile
    class="glossary-panel__term"
    :title="title"
    :sub-title="description"
		:show-title-and-subtitle-tooltip="true"
  >
    <v-menu offset-y v-if="showMenuOptions">
      <template v-slot:activator="{ on }">
        <v-btn flat v-on="on" class="lp-outline-panel-actions-button">
          <v-icon>more_vert</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-tile @click="$emit('open')">
          <v-list-tile-title class="body-1">
            <v-layout row align-center>
              <v-icon class="mr-2">mdi-open-in-new</v-icon>
              <span>Open term</span>
            </v-layout>
          </v-list-tile-title>
        </v-list-tile>

        <v-list-tile @click="$emit('remove')">
          <v-list-tile-title class="body-1">
            <v-layout row align-center>
              <v-icon class="mr-2">mdi-trash-can-outline</v-icon>
              <span>Remove</span>
            </v-layout>
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>

    <v-tooltip bottom v-else>
      <template v-slot:activator="{ on }">
        <v-btn icon flat v-on="on" @click="$emit('open')" class="lp-outline-panel-actions-button">
          <v-icon>mdi-open-in-new</v-icon>
        </v-btn>
      </template>
      <span>Open term</span>
    </v-tooltip>
  </p-property-tile>
</template>

<script>
import PPropertyTile from "../../../lessonPlan/blocks/_components/utils/PPropertyTile.vue"

export default {
  name: "GlossaryTermItem",
  components: { PPropertyTile },
  props: {
    term: {
      type: Object,
      required: true
    },
    mode: {
      type: String,
      default: "view"
    },
    allowRemove: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    title() {
      const title = this.term.body.contents.term || ""
      const acronym = this.term.body.contents.acronym

			if (acronym) return `${title} (${acronym})`
			
      return title
    },
    description() {
      return this.term.body.contents.description || ""
    },
    showMenuOptions() {
      return this.mode === 'edit' && this.allowRemove
    }
  }
}
</script>
